import { Box, Typography } from "@mui/material";
import React from "react";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

interface ErrorMessageProps {
  message: string;
}

const ErrorMessageBox = ({ message }: ErrorMessageProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      width="100%"
      padding={4}
    >
      <ErrorOutlineOutlinedIcon
        fontSize="large"
        style={{ color: "#ccc", marginBottom: 10 }}
      />
      <Typography>{message}</Typography>
    </Box>
  );
};

export default ErrorMessageBox;
